import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useIsMobile(query = "(max-width: 767px)") {
  const [match, setMatch] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatch(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return match;
}

export function usePublishedPhotos() {
  const [photos, setPhotos] = useState({});
  useEffect(() => {
    let alive = true;
    api.get("/photos")
      .then((r) => { if (alive && r.data && typeof r.data === "object") setPhotos(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return photos;
}
